import send from "../../util/request";

export const productSelect = (data = {}) => {
	return send({ url: '/ipp/product/select', method: 'POST', data });
};

export const publicLoginForCpm = (data = {}) => {
	return send({ url: '/ipp/v3/public/login-for-cpm', method: 'POST', data });
};